/**
 * Converts a Date to a plain local `YYYY-MM-DD` string.
 *
 * Uses local date components (never `toISOString`) on purpose: sending an ISO
 * timestamp would render the value in UTC and, for Poland (UTC+1/+2), shift a
 * date-only pick to the previous day. Plain local `YYYY-MM-DD` is the project
 * convention for date-only fields sent to the API.
 */
export const dateToApiString = (date: Date): string => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};

/**
 * Parses a plain `YYYY-MM-DD` string into a local Date at noon, so the calendar
 * day is preserved regardless of the browser timezone. An empty string or null
 * (the API returns `''` for an unset date) yields `null`.
 */
export const apiStringToDate = (value?: string | null): Date | null =>
  value ? new Date(`${value}T12:00:00`) : null;
